import { render } from "./edit-booking.vue?vue&type=template&id=c975ef26&ts=true"
import script from "./edit-booking.vue?vue&type=script&lang=ts"
export * from "./edit-booking.vue?vue&type=script&lang=ts"

import "./edit-booking.vue?vue&type=style&index=0&id=c975ef26&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__